import styled, { css } from "styled-components";
import { theme } from "../../styles/theme";

export const Card = styled.div`
  position: relative;
  width: 100%;
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.colors.background.secondary};
  border: ${theme.borders.base};
  padding: ${theme.spacing.xl};
  transition: border-color ${theme.transitions.fast};

  ${({ interactive }) =>
    interactive &&
    css`
    &:hover {
        border-color: ${theme.colors.stroke.strong};
    }
  `}

  ${({ padding }) =>
    padding &&
    css`
      padding: ${padding};
  `}
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.sm};
  margin-bottom: ${theme.spacing.md};
`;

export const CardTitle = styled.h3`
  font-size: ${theme.typography.fontSize.lg};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.text.primary};
`;

export const CardContent = styled.div`
  color: ${theme.colors.text.secondary};
  font-size: ${theme.typography.fontSize.sm};
`;


